
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12.545","r":"11.25","stroke":"#E6E7E9","stroke-width":"1.5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.11 11.144a1.424 1.424 0 10-2.013-2.013l-3.704 3.704-1.068-1.067a1.576 1.576 0 10-2.229 2.228l2.014 2.014a1.576 1.576 0 002.52-.4c.045-.035.088-.074.13-.115l4.35-4.35z","fill":"#E6E7E9"}})])
          )
        }
      }
    